import { GridFilterModel, GridPaginationModel, GridSortModel } from "@mui/x-data-grid-premium";
import { createSlice } from "@reduxjs/toolkit";
import VwHastauyari1DTO from "src/models/HastaUyariModels/VwHastauyari1DTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { ApiResponse } from "src/services/core";

interface IHastaUyari {
    open: boolean;
    data: HastaUyariListesiResponse;
    activeRow: VwHastauyari1DTO;
    ekleOpen: boolean;
    paginationModel: GridPaginationModel;
    sortModel: GridSortModel;
    filterModel: GridFilterModel;
};
export type HastaUyariListesiResponse = ApiResponse<Array<VwHastauyari1DTO>> & {
    isFetching?: boolean;
    isLoading?: boolean;
};
export const HastaUyariSlice = createSlice<IHastaUyari, MapReducerPayloads<IHastaUyari, {
    setOpen: boolean;
    setData: HastaUyariListesiResponse;
    setActiveRow: VwHastauyari1DTO;
    setEkleOpen: boolean;
    setPaginationModel: GridPaginationModel;
    setSortModel: GridSortModel;
    setFilterModel: GridFilterModel;
}>>({
    name: "hastaUyari",
    initialState: {
        open: false,
        data: { data: [], isFetching: false, isLoading: true, },
        activeRow: new VwHastauyari1DTO(),
        ekleOpen: false,
        paginationModel: { page: 0, pageSize: 100 },
        sortModel: [],
        filterModel: { items: [] },
    },
    reducers: {
        setOpen: (state, action) => {
            state.open = action.payload;
        },
        setData: (state, action) => {
            state.data = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        setEkleOpen: (state, action) => {
            state.ekleOpen = action.payload;
        },
        setPaginationModel: (state, action) => {
            state.paginationModel = action.payload;
        },
        setSortModel: (state, action) => {
            state.sortModel = action.payload;
        },
        setFilterModel: (state, action) => {
            state.filterModel = action.payload;
        },
    },
});